import { Routes } from '@angular/router';
import { authenticationGuard } from '@services';
import { SvgIconsPageComponent } from '@ui-lib';
import { environment } from '../environments/environment';

export const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () => import('./auth/auth.routes').then(m => m.AUTH_ROUTES),
  },
  {
    path: '',
    loadChildren: () => import('./main/main.routes').then(m => m.MAIN_ROUTES),
    canActivate: [authenticationGuard],
    canActivateChild: [authenticationGuard],
  },
  ...(!environment.production
    ? [{ path: 'icon-gallery', component: SvgIconsPageComponent }]
    : []),
];
